"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMOpCode = void 0;
var VMOpCode;
(function (VMOpCode) {
    VMOpCode[VMOpCode["PUSH_CONST"] = 0] = "PUSH_CONST";
    VMOpCode[VMOpCode["PUSH_UNDEFINED"] = 1] = "PUSH_UNDEFINED";
    VMOpCode[VMOpCode["PUSH_NULL"] = 2] = "PUSH_NULL";
    VMOpCode[VMOpCode["POP"] = 3] = "POP";
    VMOpCode[VMOpCode["DUP"] = 4] = "DUP";
    VMOpCode[VMOpCode["SWAP"] = 5] = "SWAP";
    VMOpCode[VMOpCode["LOAD_LOCAL"] = 6] = "LOAD_LOCAL";
    VMOpCode[VMOpCode["STORE_LOCAL"] = 7] = "STORE_LOCAL";
    VMOpCode[VMOpCode["LOAD_ARG"] = 8] = "LOAD_ARG";
    VMOpCode[VMOpCode["STORE_ARG"] = 9] = "STORE_ARG";
    VMOpCode[VMOpCode["ADD"] = 10] = "ADD";
    VMOpCode[VMOpCode["SUB"] = 11] = "SUB";
    VMOpCode[VMOpCode["MUL"] = 12] = "MUL";
    VMOpCode[VMOpCode["DIV"] = 13] = "DIV";
    VMOpCode[VMOpCode["MOD"] = 14] = "MOD";
    VMOpCode[VMOpCode["NEG"] = 15] = "NEG";
    VMOpCode[VMOpCode["INC"] = 16] = "INC";
    VMOpCode[VMOpCode["DEC"] = 17] = "DEC";
    VMOpCode[VMOpCode["EXPONENT"] = 18] = "EXPONENT";
    VMOpCode[VMOpCode["UNARY_PLUS"] = 19] = "UNARY_PLUS";
    VMOpCode[VMOpCode["BIT_AND"] = 20] = "BIT_AND";
    VMOpCode[VMOpCode["BIT_OR"] = 21] = "BIT_OR";
    VMOpCode[VMOpCode["BIT_XOR"] = 22] = "BIT_XOR";
    VMOpCode[VMOpCode["BIT_NOT"] = 23] = "BIT_NOT";
    VMOpCode[VMOpCode["SHL"] = 24] = "SHL";
    VMOpCode[VMOpCode["SHR"] = 25] = "SHR";
    VMOpCode[VMOpCode["USHR"] = 26] = "USHR";
    VMOpCode[VMOpCode["LOGICAL_NOT"] = 32] = "LOGICAL_NOT";
    VMOpCode[VMOpCode["EQ"] = 40] = "EQ";
    VMOpCode[VMOpCode["NEQ"] = 41] = "NEQ";
    VMOpCode[VMOpCode["STRICT_EQ"] = 42] = "STRICT_EQ";
    VMOpCode[VMOpCode["STRICT_NEQ"] = 43] = "STRICT_NEQ";
    VMOpCode[VMOpCode["LT"] = 44] = "LT";
    VMOpCode[VMOpCode["LTE"] = 45] = "LTE";
    VMOpCode[VMOpCode["GT"] = 46] = "GT";
    VMOpCode[VMOpCode["GTE"] = 47] = "GTE";
    VMOpCode[VMOpCode["JUMP"] = 50] = "JUMP";
    VMOpCode[VMOpCode["JUMP_IF_TRUE"] = 51] = "JUMP_IF_TRUE";
    VMOpCode[VMOpCode["JUMP_IF_FALSE"] = 52] = "JUMP_IF_FALSE";
    VMOpCode[VMOpCode["JUMP_NULLISH"] = 53] = "JUMP_NULLISH";
    VMOpCode[VMOpCode["CALL"] = 54] = "CALL";
    VMOpCode[VMOpCode["CALL_METHOD"] = 55] = "CALL_METHOD";
    VMOpCode[VMOpCode["RETURN"] = 56] = "RETURN";
    VMOpCode[VMOpCode["THROW"] = 57] = "THROW";
    VMOpCode[VMOpCode["TRY_START"] = 58] = "TRY_START";
    VMOpCode[VMOpCode["TRY_END"] = 59] = "TRY_END";
    VMOpCode[VMOpCode["CATCH_START"] = 60] = "CATCH_START";
    VMOpCode[VMOpCode["FINALLY_START"] = 61] = "FINALLY_START";
    VMOpCode[VMOpCode["FINALLY_END"] = 62] = "FINALLY_END";
    VMOpCode[VMOpCode["BREAK"] = 63] = "BREAK";
    VMOpCode[VMOpCode["CONTINUE"] = 64] = "CONTINUE";
    VMOpCode[VMOpCode["LABEL"] = 65] = "LABEL";
    VMOpCode[VMOpCode["GET_PROP"] = 70] = "GET_PROP";
    VMOpCode[VMOpCode["SET_PROP"] = 71] = "SET_PROP";
    VMOpCode[VMOpCode["GET_COMPUTED"] = 72] = "GET_COMPUTED";
    VMOpCode[VMOpCode["SET_COMPUTED"] = 73] = "SET_COMPUTED";
    VMOpCode[VMOpCode["DELETE_PROP"] = 74] = "DELETE_PROP";
    VMOpCode[VMOpCode["GET_GLOBAL"] = 75] = "GET_GLOBAL";
    VMOpCode[VMOpCode["SET_GLOBAL"] = 76] = "SET_GLOBAL";
    VMOpCode[VMOpCode["NEW_OBJECT"] = 77] = "NEW_OBJECT";
    VMOpCode[VMOpCode["GET_OPTIONAL"] = 78] = "GET_OPTIONAL";
    VMOpCode[VMOpCode["IN"] = 79] = "IN";
    VMOpCode[VMOpCode["HAS_OWN"] = 80] = "HAS_OWN";
    VMOpCode[VMOpCode["OBJECT_SPREAD"] = 81] = "OBJECT_SPREAD";
    VMOpCode[VMOpCode["GET_COMPUTED_OPTIONAL"] = 82] = "GET_COMPUTED_OPTIONAL";
    VMOpCode[VMOpCode["NEW_ARRAY"] = 90] = "NEW_ARRAY";
    VMOpCode[VMOpCode["ARRAY_PUSH"] = 91] = "ARRAY_PUSH";
    VMOpCode[VMOpCode["ARRAY_LENGTH"] = 92] = "ARRAY_LENGTH";
    VMOpCode[VMOpCode["SPREAD"] = 93] = "SPREAD";
    VMOpCode[VMOpCode["ARRAY_SPREAD_PUSH"] = 94] = "ARRAY_SPREAD_PUSH";
    VMOpCode[VMOpCode["NEW_FUNC"] = 100] = "NEW_FUNC";
    VMOpCode[VMOpCode["CALL_FUNC"] = 101] = "CALL_FUNC";
    VMOpCode[VMOpCode["APPLY"] = 102] = "APPLY";
    VMOpCode[VMOpCode["BIND"] = 103] = "BIND";
    VMOpCode[VMOpCode["NEW"] = 104] = "NEW";
    VMOpCode[VMOpCode["SUPER_CALL"] = 105] = "SUPER_CALL";
    VMOpCode[VMOpCode["IMPORT_DYNAMIC"] = 106] = "IMPORT_DYNAMIC";
    VMOpCode[VMOpCode["TYPEOF"] = 110] = "TYPEOF";
    VMOpCode[VMOpCode["INSTANCEOF"] = 111] = "INSTANCEOF";
    VMOpCode[VMOpCode["TYPEOF_GLOBAL"] = 112] = "TYPEOF_GLOBAL";
    VMOpCode[VMOpCode["YIELD"] = 120] = "YIELD";
    VMOpCode[VMOpCode["YIELD_STAR"] = 121] = "YIELD_STAR";
    VMOpCode[VMOpCode["AWAIT"] = 122] = "AWAIT";
    VMOpCode[VMOpCode["ITERATOR_NEXT"] = 123] = "ITERATOR_NEXT";
    VMOpCode[VMOpCode["ITERATOR_RETURN"] = 124] = "ITERATOR_RETURN";
    VMOpCode[VMOpCode["ITERATOR_THROW"] = 125] = "ITERATOR_THROW";
    VMOpCode[VMOpCode["FOR_OF_START"] = 126] = "FOR_OF_START";
    VMOpCode[VMOpCode["GET_ITERATOR"] = 127] = "GET_ITERATOR";
    VMOpCode[VMOpCode["ITERATOR_DONE"] = 128] = "ITERATOR_DONE";
    VMOpCode[VMOpCode["NEW_CLASS"] = 140] = "NEW_CLASS";
    VMOpCode[VMOpCode["CLASS_EXTENDS"] = 141] = "CLASS_EXTENDS";
    VMOpCode[VMOpCode["GET_SUPER_PROP"] = 142] = "GET_SUPER_PROP";
    VMOpCode[VMOpCode["DEFINE_METHOD"] = 144] = "DEFINE_METHOD";
    VMOpCode[VMOpCode["DEFINE_GETTER"] = 145] = "DEFINE_GETTER";
    VMOpCode[VMOpCode["DEFINE_SETTER"] = 146] = "DEFINE_SETTER";
    VMOpCode[VMOpCode["DEFINE_STATIC_METHOD"] = 147] = "DEFINE_STATIC_METHOD";
    VMOpCode[VMOpCode["DEFINE_STATIC_GETTER"] = 148] = "DEFINE_STATIC_GETTER";
    VMOpCode[VMOpCode["DEFINE_STATIC_SETTER"] = 149] = "DEFINE_STATIC_SETTER";
    VMOpCode[VMOpCode["THIS"] = 160] = "THIS";
    VMOpCode[VMOpCode["ARGUMENTS"] = 161] = "ARGUMENTS";
    VMOpCode[VMOpCode["NEW_REGEX"] = 162] = "NEW_REGEX";
    VMOpCode[VMOpCode["VOID"] = 163] = "VOID";
    VMOpCode[VMOpCode["NEW_TARGET"] = 164] = "NEW_TARGET";
    VMOpCode[VMOpCode["COMMA"] = 166] = "COMMA";
    VMOpCode[VMOpCode["SYMBOL"] = 167] = "SYMBOL";
    VMOpCode[VMOpCode["SYMBOL_FOR"] = 168] = "SYMBOL_FOR";
    VMOpCode[VMOpCode["SYMBOL_KEY_FOR"] = 169] = "SYMBOL_KEY_FOR";
    VMOpCode[VMOpCode["DEBUGGER"] = 200] = "DEBUGGER";
    VMOpCode[VMOpCode["NOP"] = 201] = "NOP";
    VMOpCode[VMOpCode["END"] = 202] = "END";
    VMOpCode[VMOpCode["DEFINE_METHOD_COMPUTED"] = 170] = "DEFINE_METHOD_COMPUTED";
    VMOpCode[VMOpCode["DEFINE_STATIC_METHOD_COMPUTED"] = 171] = "DEFINE_STATIC_METHOD_COMPUTED";
    VMOpCode[VMOpCode["DEFINE_GETTER_COMPUTED"] = 172] = "DEFINE_GETTER_COMPUTED";
    VMOpCode[VMOpCode["DEFINE_SETTER_COMPUTED"] = 173] = "DEFINE_SETTER_COMPUTED";
    VMOpCode[VMOpCode["DEFINE_STATIC_GETTER_COMPUTED"] = 174] = "DEFINE_STATIC_GETTER_COMPUTED";
    VMOpCode[VMOpCode["DEFINE_STATIC_SETTER_COMPUTED"] = 175] = "DEFINE_STATIC_SETTER_COMPUTED";
    VMOpCode[VMOpCode["CREATE_ENV"] = 210] = "CREATE_ENV";
    VMOpCode[VMOpCode["LOAD_FROM_ENV"] = 211] = "LOAD_FROM_ENV";
    VMOpCode[VMOpCode["STORE_TO_ENV"] = 212] = "STORE_TO_ENV";
    VMOpCode[VMOpCode["GET_ENV"] = 213] = "GET_ENV";
    VMOpCode[VMOpCode["RESTORE_PARENT_ENV"] = 214] = "RESTORE_PARENT_ENV";
    VMOpCode[VMOpCode["STORE_TO_CURRENT_ENV"] = 215] = "STORE_TO_CURRENT_ENV";
    VMOpCode[VMOpCode["STORE_TO_ENV_CONST"] = 216] = "STORE_TO_ENV_CONST";
    VMOpCode[VMOpCode["STORE_TO_CURRENT_ENV_CONST"] = 217] = "STORE_TO_CURRENT_ENV_CONST";
    VMOpCode[VMOpCode["DECLARE_TDZ"] = 218] = "DECLARE_TDZ";
    VMOpCode[VMOpCode["MACRO_INC_LOCAL"] = 250] = "MACRO_INC_LOCAL";
    VMOpCode[VMOpCode["MACRO_DEC_LOCAL"] = 251] = "MACRO_DEC_LOCAL";
    VMOpCode[VMOpCode["MACRO_ADD_LOCAL_CONST"] = 252] = "MACRO_ADD_LOCAL_CONST";
    VMOpCode[VMOpCode["MACRO_SUB_LOCAL_CONST"] = 253] = "MACRO_SUB_LOCAL_CONST";
    VMOpCode[VMOpCode["MACRO_MUL_LOCAL_CONST"] = 254] = "MACRO_MUL_LOCAL_CONST";
    VMOpCode[VMOpCode["MACRO_LOAD_LOCAL_GET_PROP"] = 255] = "MACRO_LOAD_LOCAL_GET_PROP";
    VMOpCode[VMOpCode["MACRO_LT_LOCAL_CONST"] = 256] = "MACRO_LT_LOCAL_CONST";
    VMOpCode[VMOpCode["MACRO_JUMP_IF_LOCAL_LT_CONST"] = 257] = "MACRO_JUMP_IF_LOCAL_LT_CONST";
    VMOpCode[VMOpCode["MACRO_CALL_LOCAL_METHOD"] = 258] = "MACRO_CALL_LOCAL_METHOD";
    VMOpCode[VMOpCode["MACRO_STORE_LOCAL_POP"] = 259] = "MACRO_STORE_LOCAL_POP";
    VMOpCode[VMOpCode["MACRO_INC_LOCAL_PRE"] = 260] = "MACRO_INC_LOCAL_PRE";
    VMOpCode[VMOpCode["MACRO_DEC_LOCAL_PRE"] = 261] = "MACRO_DEC_LOCAL_PRE";
})(VMOpCode || (exports.VMOpCode = VMOpCode = {}));
